import { GradeMaterials } from 'src/app/shared/models/grade-materials.model';

export const GRADES_2_3_MATERIALS: GradeMaterials = {
  categories: [
    {
      headingEn: 'Introductory items',
      headingEs: 'Elementos introductorios',
      items: [
        {
          id: 'program-guide-2-3',
          labelEn: 'Program Guide 2—3',
          labelEs: 'Guía del programa 2—3',
          subLabelEn: 'website\'s program section',
          subLabelEs: 'sección del programa de la página web',
          filePath: 'assets/printables/en/2-3/Program_Guide_2-3.pdf',
          filePathEs: 'assets/printables/es/2-3/Program_Guide_2-3_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'letter-parents-2-3',
          labelEn: 'Letter to parents',
          labelEs: 'Carta para los padres',
          filePath: 'assets/printables/en/2-3/Letter_Parents_2-3.pdf',
          filePathEs: 'assets/printables/es/2-3/Letter_Parents_2-3_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'letter-administrator-2-3',
          labelEn: 'Letter to administrator',
          labelEs: 'Carta para los administradores',
          filePath: 'assets/printables/en/2-3/Letter_Administrator_2-3.docx',
          filePathEs: 'assets/printables/es/2-3/Letter_Administrator_2-3_ES.docx',
          iconType: 'doc'
        }
      ]
    },
    {
      headingEn: 'Employment',
      headingEs: 'Empleo',
      items: [
        {
          id: 'payday-video-2-3',
          labelEn: 'Payday video',
          labelEs: 'Video sobre el día de pago',
          filePath: 'assets/video/CE_S01.mp4',
          filePathEs: 'assets/video/CE_S01.mp4',
          iconType: 'video'
        },
        {
          id: 'job-application-2-3',
          labelEn: 'Job application',
          labelEs: 'Aplicación de trabajo',
          filePath: 'assets/printables/en/2-3/Job_Application_2-3.pdf',
          filePathEs: 'assets/printables/es/2-3/Job_Application_2-3_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'job-posters-2-3',
          labelEn: 'Job posters',
          labelEs: 'Afiches de trabajo',
          filePath: 'assets/printables/en/2-3/Job_Posters_2-3.pdf',
          filePathEs: 'assets/printables/es/2-3/Job_Posters_2-3_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'paycheck-2-3',
          labelEn: 'Paycheck',
          labelEs: 'Sueldo',
          filePath: 'assets/printables/en/2-3/Paycheck_2-3.pdf',
          filePathEs: 'assets/printables/es/2-3/Paycheck_2-3_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Banking',
      headingEs: 'Bancario/a',
      items: [
        {
          id: 'bank-log-2-3',
          labelEn: 'Bank log',
          labelEs: 'Registro bancario',
          filePath: 'assets/printables/en/2-3/Bank_Log_2-3.pdf',
          filePathEs: 'assets/printables/es/2-3/Bank_Log_2-3_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Fines & tickets',
      headingEs: 'Multas',
      items: [
        {
          id: 'fine-ticket-2-3',
          labelEn: 'Fine tickets',
          labelEs: 'Tiquetes de multa',
          filePath: 'assets/printables/en/2-3/Fine_Ticket_2-3.pdf',
          filePathEs: 'assets/printables/es/2-3/Fine_Ticket_2-3_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'offense-log-2-3',
          labelEn: 'Offense log',
          labelEs: 'Registro de ofensas',
          filePath: 'assets/printables/en/2-3/Offense_Log_2-3.pdf',
          filePathEs: 'assets/printables/es/2-3/Offense_Log_2-3_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Cash',
      headingEs: 'Dinero',
      items: [
        {
          id: 'bills-5-2-3',
          labelEn: '$5 bills',
          labelEs: 'Billetes de $5',
          filePath: 'assets/printables/en/2-3/Bills_5_2-3.pdf',
          filePathEs: 'assets/printables/es/2-3/Bills_5_2-3_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'bills-10-2-3',
          labelEn: '$10 bills',
          labelEs: 'Billetes de $10',
          filePath: 'assets/printables/en/2-3/Bills_10_2-3.pdf',
          filePathEs: 'assets/printables/es/2-3/Bills_10_2-3_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'bills-20-2-3',
          labelEn: '$20 bills',
          labelEs: 'Billetes de $20',
          filePath: 'assets/printables/en/2-3/Bills_20_2-3.pdf',
          filePathEs: 'assets/printables/es/2-3/Bills_20_2-3_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'bills-50-2-3',
          labelEn: '$50 bills',
          labelEs: 'Billetes de $50',
          filePath: 'assets/printables/en/2-3/Bills_50_2-3.pdf',
          filePathEs: 'assets/printables/es/2-3/Bills_50_2-3_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Rent & deeds',
      headingEs: 'Alquiler y título de propiedad',
      items: [
        {
          id: 'unpaid-rent-notice-2-3',
          labelEn: 'Unpaid rent notice',
          labelEs: 'Aviso de renta no pagada',
          filePath: 'assets/printables/en/2-3/Unpaid_Rent_Notice_2-3.pdf',
          filePathEs: 'assets/printables/es/2-3/Unpaid_Rent_Notice_2-3_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'desk-deed-2-3',
          labelEn: 'Deed to desk',
          labelEs: 'Título de propiedad del escritorio',
          filePath: 'assets/printables/en/2-3/Desk_Deed_2-3.pdf',
          filePathEs: 'assets/printables/es/2-3/Desk_Deed_2-3_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Auctions',
      headingEs: 'Subastas',
      items: [
        {
          id: 'auction-video-2-3',
          labelEn: 'Auction video',
          labelEs: 'Video sobre subastas',
          filePath: 'assets/video/CE_S04.mp4',
          filePathEs: 'assets/video/CE_S04.mp4',
          iconType: 'video'
        },
        {
          id: 'auction-record-2-3',
          labelEn: 'Auction record form',
          labelEs: 'Formulario de registro de subasta',
          filePath: 'assets/printables/en/2-3/Auction_Record_2-3.pdf',
          filePathEs: 'assets/printables/es/2-3/Auction_Record_2-3_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'auction-paddle-2-3',
          labelEn: 'Auction paddle',
          labelEs: 'Paleta de subastas',
          filePath: 'assets/printables/en/2-3/Auction_Paddle_2-3.pdf',
          filePathEs: 'assets/printables/es/2-3/Auction_Paddle_2-3_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Year-end certificates',
      headingEs: 'Certificados de fin de año',
      items: [
        {
          id: 'saver-certs-2-3',
          labelEn: 'Saver certificates (Includes Saver, Super, and Ultimate awards)',
          labelEs: 'Certificado de ahorro (Incluye los premios Saver, Super y Ultimate)',
          filePath: 'assets/printables/en/2-3/Saver_Certs_2-3.pdf',
          filePathEs: 'assets/printables/es/2-3/Saver_Certs_2-3_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Posters & handouts',
      headingEs: 'Afiches y folletos',
      items: [
        {
          id: 'bonus-list-2-3',
          labelEn: 'Bonus list',
          labelEs: 'Lista de bonificaciones',
          filePath: 'assets/printables/en/2-3/Bonus_List_2-3.docx',
          filePathEs: 'assets/printables/es/2-3/Bonus_List_2-3_ES.doc',
          iconType: 'doc'
        },
        {
          id: 'fine-list-2-3',
          labelEn: 'Fine list',
          labelEs: 'Lista de multas',
          filePath: 'assets/printables/en/2-3/Fine_List_2-3.docx',
          filePathEs: 'assets/printables/es/2-3/Fine_List_2-3_ES.doc',
          iconType: 'doc'
        }
      ]
    }
  ],
  supplies: {
    headingEn: 'Supplies to have on hand',
    headingEs: 'Suministros para tener al alcance',
    items: [
      { labelEn: 'Envelopes', labelEs: 'Sobres' },
      { labelEn: 'Portfolio folders', labelEs: 'Carpetas de portafolios' },
      { labelEn: 'Cash drawer or box', labelEs: 'Caja de dinero' },
      { labelEn: 'Popsicle sticks for auction paddles', labelEs: 'Palos de paleta para las paletas de subasta' },
      { labelEn: 'Sticky notes', labelEs: 'Notas adhesivas' },
      { labelEn: 'Clipboard', labelEs: 'Portapapeles' },
      { labelEn: 'Auction items', labelEs: 'Artículos de subasta' }
    ]
  }
};
